export default __webpack_public_path__ + "static/Steph(1)-17a78270e794819f41dafa59bd7bf7cf.png";